'use strict';

angular.module('cimerFrontEndApp').directive('division', ['$http', 'ApiUrl',
function ($http, ApiUrl) {
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/divisionTemplate.html',
        scope: {
            divisionID: '=ngModel',
            projectID: '=projectId',
            classes: '@classes',
            isRequired: '=?isRequired'
        },
        require: ['^form', 'ngModel'],
        link: function (scope, elements, attrs, ctrls) {
            var ngModel = ctrls[1];
            var _apiUrl = ApiUrl.url('/Division/');

            var updateDivisions = function (projectID) {
                if (!projectID) {
                    return;
                }
                $http.get(_apiUrl + 'Divisions/' + projectID).then(function (response) {
                    scope.divisions = response.data;
                }, function (err) {
                    //TODO: error
                });
            };

            scope.$watch('projectID',
                function(newVal, oldVal) {
                    updateDivisions(newVal);
                },
                true);
        }
    };
}]);
